import React from 'react';
import { inject, observer } from 'mobx-react';
import Link from 'next/link';
import Router from 'next/router';

import Login from './Login';

const Logo = '/static/img/logo-white.svg';
const LogoColored = '/static/img/logo-colored.svg';
const BlueCloseIcon = '/static/img/icon-close-blue.svg';
const WhiteHamburgerIcon = '/static/img/icon-hamburger-white.svg';

@inject('stores')
@observer
class Navbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = { menuOpen: false, loginModalOpen: false };
  }

  switchMenu = () => {
    this.setState(prevState => ({ menuOpen: !prevState.menuOpen }));
  }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  logout = () => {
    this.props.stores.userStore.logout();
    this.props.stores.cartStore.removeOrder();

    if (this.props.protected) Router.push('/');
  }

  openLoginModal = () => {
    this.setState({ loginModalOpen: true });
  };

  closeLoginModal = () => {
    this.setState({ loginModalOpen: false });
  };

  render() {
    const { loggedIn } = this.props.stores.userStore;

    return (
      <React.Fragment>
        <div className="navbar-mobile">
          <Link href="/">
            <a>
              <img src={Logo} className="logo" alt="ThinkVirtues" />
            </a>
          </Link>
          <button type="button" onClick={() => this.switchMenu()}>
            <img
              src={WhiteHamburgerIcon}
              className="hamburger"
              alt="Open Menu"
            />
          </button>
        </div>
        <nav className={this.state.menuOpen ? 'navbar open' : 'navbar'}>
          <div className="container">
            <img
              role="presentation"
              src={BlueCloseIcon}
              alt="Close"
              className="icon-close-blue"
              onClick={() => this.switchMenu()}
            />
            <div className="navbar-left">
              <div className="navbar-logo">
                <Link href="/">
                  <a>
                    <img
                      src={this.props.logoType === 'white' ? Logo : LogoColored}
                      alt="ThinkVirtues"
                    />
                  </a>
                </Link>
              </div>
            </div>
            <div className="navbar-right">
              <Link href="/education">
                <a className="nav-link">Educational</a>
              </Link>
              <Link href="/business">
                <a className="nav-link">For Business</a>
              </Link>
              <Link href="/thinktank">
                <a className="nav-link">ThinkTank</a>
              </Link>
              <Link href="/contact">
                <a className="nav-link">Contact</a>
              </Link>
              <Link href="#">
                <a className="nav-link">Community</a>
              </Link>
              <Link href="/blog">
                <a className="nav-link">Blog</a>
              </Link>
              <Link href="/products">
                <a className="nav-link">Shop</a>
              </Link>

              {loggedIn ? (
                <React.Fragment>
                  <Link href="/dashboard">
                    <a className="nav-link">Dashboard</a>
                  </Link>
                  <button
                    type="button"
                    className="nav-link"
                    onClick={() => this.logout()}
                  >
                    Logout
                  </button>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <button
                    type="button"
                    className="nav-link"
                    onClick={() => {
                      this.setState({ menuOpen: false });
                      this.openLoginModal();
                    }}
                  >
                    Dashboard
                  </button>
                  <button
                    type="button"
                    className="nav-link login-button"
                    onClick={() => {
                      this.setState({ menuOpen: false });
                      this.openLoginModal();
                    }}
                  >
                    Login
                  </button>
                </React.Fragment>
              )}
            </div>
          </div>
        </nav>
        <Login
          open={this.state.loginModalOpen}
          closeLoginModal={this.closeLoginModal}
        />
      </React.Fragment>
    );
  }
}

export default Navbar;
